<template>
  <div>
    <a-form-model
      class="fromStyle"
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="项目" ref="project_id" prop="project_id">
        <a-select
          style="width:300px"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="form.project_id"
          placeholder="请选择项目"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item ref="is_frame" label="有无边柜" prop="is_frame">
        <a-radio-group v-model="form.is_frame">
          <a-radio :value="1">有边柜</a-radio>
          <a-radio :value="2">无边柜</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item ref="getToken" label="示例图" prop="getToken">
        <div class="upImage">
          <input type="file" accept="image/*" @change="changeImg" />
          <img :src="form.upImgSrc" alt="" />
        </div>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 10, offset: 5 }">
        <a-button @click="resetForm">
          重置
        </a-button>
        <a-button style="margin-left: 10px;" type="primary" @click="onSubmit">
          提交
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import axios from "axios";
import * as qiniu from "qiniu-js";
export default {
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 12 },
      form: {
        project_id: "",
        version: "",
        is_frame: "",
        getToken: "",
        upImgSrc: require("../../assets/equipment/add.png")
      },
      rules: {
        getToken: [
          {
            required: true,
            message: "请选择示例图",
            trigger: "change"
          }
        ],
        is_frame: [
          {
            required: true,
            message: "请选择有无边柜",
            trigger: "change"
          }
        ],
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ]
      },
      proList: []
    };
  },
  mounted() {
    this.getPro();
    if (this.editDetail != undefined) {
      this.getDetail();
    }
  },
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      // console.log(this.editDetail);
      this.form = {
        project_id: this.editDetail.project_id,
        is_frame: this.editDetail.is_frame,
        getToken: this.editDetail.image,
        upImgSrc:
          this.editDetail.imageUrl == undefined
            ? ""
            : this.editDetail.imageUrl.url_thumb
      };
    },
    changeImg(e) {
      if (e.target.files != "") {
        this.getUpImgToken(e);
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onloadend = () => {
          this.form.upImgSrc = reader.result;
        };
      }
    }, //注意事项图片
    getUpImgToken(e) {
      let self = this;
      let url = this.httpsBasic.url + "cloud/Qiniu/getToken";
      axios
        .post(url, {
          count: 1
        })
        .then(res => {
          this.form.getToken = res.data.data.business_file_key;
          this.$refs.ruleForm.validateField("getToken", valid => {});
          // console.log(this.getToken1);
          var config = {
            useCdnDomain: true,
            region: qiniu.region.z0
          };
          var putExtra = {
            fname: "",
            params: {},
            mimeType: null
          };
          var observable = qiniu.upload(
            e.target.files[0],
            res.data.data.keys[0],
            res.data.data.token,
            putExtra,
            config
          );
          var observer = {
            next(res) {
              // console.log("上传中...");
            },
            error(err) {
              // console.log(err)
              self.$info({
                title: "提示",
                content: "错误码：" + err.code + "！请重新选择图片",
                onOk() {}
              });
              self.form.upImgSrc = "";
            },
            complete(res) {
              // console.log("上传成功");
            }
          };
          var subscription = observable.subscribe(observer); // 上传开始
        });
    }, //上传至七牛云
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // alert("submit!");
          let url =
            this.httpsBasic.url +
            this.httpsBasic.equipment +
            "Mc_examples/edit";
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            id: this.editDetail.id,
            project_id: this.form.project_id,
            image: this.form.getToken,
            is_frame: this.form.is_frame
          };
          // console.log(params);
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$message.success("提交成功");
              this.resetForm();
              this.$emit("hideInEdit", true);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.form.upImgSrc = require("../../assets/equipment/add.png");
    }
  }
};
</script>
<style lang="less" scoped>
.fromStyle {
  .upImage {
    width: 100px;
    height: 100px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #ccc;
    }
    input {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
      opacity: 0;
    }
  }
}
</style>
<style lang="less">
.fromStyle {
  margin-top: 30px;
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
    line-height: 32px;
  }
}
</style>
